import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '/more/discover_obs/observation.png'


const _hoisted_1 = { class: "mt-6 lg:mt-8" }
const _hoisted_2 = { class: "mt-20" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12" }
const _hoisted_4 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_5 = { class: "p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg" }
const _hoisted_6 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_7 = { class: "p-3 bg-red-100 dark:bg-red-900/30 rounded-lg" }
const _hoisted_8 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_9 = { class: "p-3 bg-green-100 dark:bg-green-900/30 rounded-lg" }
const _hoisted_10 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_11 = { class: "p-3 bg-purple-100 dark:bg-purple-900/30 rounded-lg" }
const _hoisted_12 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_13 = { class: "p-3 bg-orange-100 dark:bg-orange-900/30 rounded-lg" }
const _hoisted_14 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_15 = { class: "p-3 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg" }
const _hoisted_16 = { class: "mt-20" }
const _hoisted_17 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-12 mt-12 items-stretch" }
const _hoisted_18 = { class: "lg:col-span-1 flex flex-col justify-center space-y-6" }
const _hoisted_19 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_20 = { class: "p-2 bg-blue-500 rounded-lg" }
const _hoisted_21 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_22 = { class: "p-2 bg-green-500 rounded-lg" }
const _hoisted_23 = { class: "mt-20" }
const _hoisted_24 = { class: "flex flex-col md:flex-row gap-8 w-full mt-8" }

import { Motion } from "motion-v";


export default /*@__PURE__*/_defineComponent({
  __name: 'progress-observations',
  setup(__props) {

defineOgImage("MainOg", {
  title: "Progress & Observations - Resident Tracking & Assessment",
  description:
    "Log detailed observations, track resident progress, and monitor assessment goals with visual insights. Streamline safeguarding, risk management, and comprehensive reporting.",
  theme: "#bc9fff",
  colorMode: "light",
});

useSeoMeta({
  title: "Progress & Observations - Resident Tracking & Assessment | FamilyAxis",
  description:
    "Log detailed observations, track resident progress, and monitor assessment goals with visual insights. Streamline safeguarding, risk management, and comprehensive reporting.",
  keywords:
    "family assessment, family assessment centres, progress tracking, observations, resident assessment, safeguarding, risk management, care documentation, visual insights, reporting",
  author: "FamilyAxis",
  ogTitle: "Progress & Observations - Resident Tracking & Assessment | FamilyAxis",
  ogDescription:
    "Log detailed observations, track resident progress, and monitor assessment goals with visual insights. Streamline safeguarding, risk management, and comprehensive reporting.",
  ogUrl: "https://familyaxis.com/more/progress-observations",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Progress & Observations - Resident Tracking & Assessment | FamilyAxis",
  twitterDescription:
    "Log detailed observations, track resident progress, and monitor assessment goals with visual insights.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

useHead({
  link: [
    {
      rel: "canonical",
      href: "https://familyaxis.com/more/progress-observations",
    },
  ],
});

const observationFeatures = ref([
  {
    title: "Effortless Observation Creation",
    description:
      "Quickly create detailed observations for any parent, assigning categories and scores with a few clicks.",
    video: "https://assets.familyaxis.com" + "/obs_creation.mp4",
  },
  {
    title: "Targeted Analysis",
    description:
      "Select specific parents and observation categories to focus your analysis and reporting.",
    video: "https://assets.familyaxis.com" + "/obs_residents_selection_category.mp4",
  },
  {
    title: "Visual Insights",
    description:
      "Turn data into understanding with visual graphs and charts that highlight trends and key insights.",
    video: "https://assets.familyaxis.com" + "/insights_obs.mp4",
  },
  {
    title: "Key Metrics at a Glance",
    description:
      "Use metrics and stats to get an immediate overview of observation data and parent progress.",
    video: "https://assets.familyaxis.com" + "/obs_stats_metters.mp4",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_UPageHeader = _resolveComponent("UPageHeader")!
  const _component_LazyVideoFeatureCard = _resolveComponent("LazyVideoFeatureCard")!
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UCard = _resolveComponent("UCard")!
  const _component_LazyShowCaseCard = _resolveComponent("LazyShowCaseCard")!
  const _component_LazyStartSignup = _resolveComponent("LazyStartSignup")!
  const _component_UPageBody = _resolveComponent("UPageBody")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, { class: "pt-10" }, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHeader, {
            title: "Progress & Observations",
            description: "Log detailed observations, track resident progress, and monitor assessment goals with visual insights and safeguarding tools."
          }),
          _createVNode(_component_UPageBody, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_LazyVideoFeatureCard, {
                  "section-title": "Create and analyse observations",
                  "section-description": "Our platform makes it easy to log, track, and review observations, ensuring consistency and alignment with your assessment goals.",
                  features: _unref(observationFeatures),
                  orientation: "right"
                }, null, 8, ["features"])
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_UPageHero, {
                  title: "Observation Features",
                  description: "Everything you need to document, track, and analyse resident progress with precision and clarity.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold',
            }
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.1 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-eye",
                                class: "h-6 w-6 text-blue-600 dark:text-blue-400"
                              })
                            ]),
                            _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Detailed Observation Logging", -1))
                          ]),
                          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Capture observations with customisable templates, categories, and a 5-tier rating system for consistent documentation. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.2 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-shield-exclamation",
                                class: "h-6 w-6 text-red-600 dark:text-red-400"
                              })
                            ]),
                            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Safeguarding Alerts", -1))
                          ]),
                          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Automatic alerts for urgent concerns trigger immediate safeguarding forms and risk assessment updates to ensure swift action. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.3 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-chart-bar-square",
                                class: "h-6 w-6 text-green-600 dark:text-green-400"
                              })
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Visual Progress Tracking", -1))
                          ]),
                          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Transform data into actionable insights with visual graphs and charts that highlight trends and key progress indicators. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.4 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-funnel",
                                class: "h-6 w-6 text-purple-600 dark:text-purple-400"
                              })
                            ]),
                            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Targeted Analysis", -1))
                          ]),
                          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Filter and analyse observations by resident, category, or time period to focus on specific areas of concern or progress. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.5 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-document-text",
                                class: "h-6 w-6 text-orange-600 dark:text-orange-400"
                              })
                            ]),
                            _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Automated Reporting", -1))
                          ]),
                          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Generate comprehensive reports automatically from observation data, ensuring consistent documentation for assessments and court proceedings. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.6 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-users",
                                class: "h-6 w-6 text-indigo-600 dark:text-indigo-400"
                              })
                            ]),
                            _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Parent Profile Integration", -1))
                          ]),
                          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Each parent profile features dedicated observation spaces, making it easy to review individual progress and patterns in focused views. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_UPageHero, {
                  title: "Dashboards & Parent Views",
                  description: "Move seamlessly from a complete overview of all activity to the detailed story of a single family with dedicated observation spaces.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold text-center',
              description:
                'text-lg sm:text-xl/8 text-muted dark:text-neutral-300 max-w-180 text-center mx-auto',
            }
                }),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(Motion), {
                    as: "div",
                    class: "lg:col-span-2 flex justify-center lg:justify-start",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.1 }
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("div", { class: "w-full rounded-lg overflow-hidden shadow-lg" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "Main Observations Dashboard",
                          class: "w-full h-full object-cover",
                          loading: "lazy"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_unref(Motion), {
                      as: "div",
                      class: "p-6 bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-950/20 dark:to-indigo-950/20 rounded-xl border border-blue-200 dark:border-blue-800/40 flex flex-col justify-center h-full",
                      initial: { opacity: 0, y: 20 },
                      "while-in-view": { opacity: 1, y: 0 },
                      viewport: { once: true },
                      transition: { duration: 0.4, delay: 0.2 }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-squares-2x2",
                              class: "h-5 w-5 text-white"
                            })
                          ]),
                          _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "text-lg font-semibold text-blue-900 dark:text-blue-100" }, " Main Observations Hub ", -1))
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-blue-800 dark:text-blue-200 text-sm" }, " Serves as your central hub for all recorded observations. Easily sort and filter the complete list to quickly find the exact information you need. ", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Motion), {
                      as: "div",
                      class: "p-6 bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-950/20 dark:to-emerald-950/20 rounded-xl border border-green-200 dark:border-green-800/40 flex flex-col justify-center h-full",
                      initial: { opacity: 0, y: 20 },
                      "while-in-view": { opacity: 1, y: 0 },
                      viewport: { once: true },
                      transition: { duration: 0.4, delay: 0.3 }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_UIcon, {
                              name: "i-heroicons-user-circle",
                              class: "h-5 w-5 text-white"
                            })
                          ]),
                          _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-lg font-semibold text-green-900 dark:text-green-100" }, " Individual Parent Profiles ", -1))
                        ]),
                        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-green-800 dark:text-green-200 text-sm" }, " Features dedicated spaces for observations, making it easy to review individual progress, patterns, and concerns in a single, focused view. ", -1))
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_UPageHero, {
                  title: "Continue Your Journey",
                  description: "Discover connected features that make managing every aspect of your centre easier.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold',
            }
                }),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_LazyShowCaseCard, {
                    title: "Team Collaboration",
                    description: "Assign tasks, share updates, and work together seamlessly across your organisation.",
                    icon: "i-heroicons-user-group",
                    image: "/images/tasks_preview.svg",
                    "image-position": "right",
                    link: "/more/team-collaboration",
                    class: "w-full md:w-4/7 h-110"
                  }),
                  _createVNode(_component_LazyShowCaseCard, {
                    title: "Centralised Dashboard",
                    description: "Manage all your operations from a single dashboard",
                    icon: "i-heroicons-computer-desktop",
                    image: "/images/dash_preview.webp",
                    "image-position": "bottom",
                    link: "/more/centralised-dashboard",
                    class: "w-full md:w-3/7 h-110"
                  })
                ])
              ]),
              _createVNode(_component_LazyStartSignup)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})